import React from "react"
import { Paper, Stack, Avatar, Box, Typography, Chip, alpha } from "@mui/material"
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export default function Header(props) {

    return <>
        <Paper
            elevation={0}
            sx={{
                p: { xs: 1, md: 2 },
                mb: 2,
                borderRadius: 3,
                color: "#fff",
                background: `linear-gradient(120deg, ${props.BRAND.dark} 0%, ${props.BRAND.main} 100%)`,
                boxShadow: "0 10px 30px rgba(27,79,114,0.25)",
            }}
        >
            <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                justifyContent="space-between"
                spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            bgcolor: alpha("#ffffff", 0.18),
                            color: "#fff",
                            width: 52,
                            height: 52,
                        }}
                    >
                        <ReceiptLongIcon fontSize="large" />
                    </Avatar>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                            {props.title}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
                            {props.subtitle}
                        </Typography>
                    </Box>
                </Stack>
                {
                    props.chipIcon && props.label && (
                        <Chip
                            icon={props.chipIcon}
                            label={props.label}
                            sx={{
                                bgcolor: "rgba(255,255,255,0.16)",
                                color: props.BRAND.contrast,
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                px: 1,
                                height: 36,
                            }}
                        />
                    )
                }
            </Stack>
        </Paper>
    </>
}



